interface ErrorMessage {
  message: string;
  type: 'error' | 'warning' | 'info';
}

const errorMessages: Record<string, ErrorMessage> = {
  'auth/registration_status': {
    message: 'Your registration is pending approval. Please check back later!.',
    type: 'error'
  },
  'auth/old_password_incorrect': {
    message: 'Old password is incorrect',
    type: 'error'
  },
  'auth/invalid_credentials': {
    message: 'Invalid email or password. Please try again.',
    type: 'error'
  },
  'auth/email_taken': {
    message: 'This email is already registered. Please use a different email or try logging in.',
    type: 'error'
  },
  'auth/username_taken': {
    message: 'This username is already taken. Please choose a different username.',
    type: 'error'
  },
  'auth/password_requirements': {
    message: 'Password does not meet the requirements. Please ensure it has at least 8 characters, including letters, numbers, and special characters.',
    type: 'error'
  },
  'auth/email_verification': {
    message: 'Please verify your email address before logging in.',
    type: 'warning'
  },
  'auth/account_locked': {
    message: 'Your account has been locked due to multiple failed login attempts. Please contact support.',
    type: 'error'
  },
  'auth/token_expired': {
    message: 'Your session has expired. Please log in again.',
    type: 'info'
  },
  'auth/2fa_required': {
    message: 'Two-factor authentication is required for this account.',
    type: 'info'
  },
  'auth/2fa_invalid': {
    message: 'Invalid two-factor authentication code. Please try again.',
    type: 'error'
  }
};

export const getErrorMessage = (loc: string): ErrorMessage => {
  return errorMessages[loc] || {
    message: 'An unexpected error occurred. Please try again.',
    type: 'error'
  };
};

export const formatErrorResponse = (error: any): ErrorMessage => {
  if (error.response?.data?.detail) {
    const details = Array.isArray(error.response.data.detail) 
      ? error.response.data.detail 
      : [error.response.data.detail];
    
    for (const detail of details) {
      if (detail.loc) {
        return getErrorMessage(detail.loc);
      }
    }
  }
  
  return {
    message: error.response?.data?.detail || 'An unexpected error occurred. Please try again.',
    type: 'error'
  };
}; 